import { jsx as e } from "react/jsx-runtime";
import { Form as m, Radio as a } from "antd";
import { R as c } from "../../../CheckOutlined-CJS8wb6a.js";
import { R as f } from "../../../CloseOutlined-CTXw7BrO.js";
const i = [
  { label: "ALL", value: "" },
  { label: /* @__PURE__ */ e(c, {}), value: "1" },
  { label: /* @__PURE__ */ e(f, {}), value: "0" }
], v = ({ formItemProps: o, radioGroupProps: t, averageWidth: l = !0 }) => {
  const n = (t == null ? void 0 : t.options) || i;
  return /* @__PURE__ */ e(m.Item, { ...o, children: /* @__PURE__ */ e(
    a.Group,
    {
      optionType: "button",
      buttonStyle: "solid",
      className: l ? "w-avg" : "",
      options: n,
      ...t
    }
  ) });
};
export {
  v as BooleanRadioButton
};
